<div class="energy-gauge">
  <div class="gauge-head">
    <div class="value-blocks">
      <div class="value-block">
        <span class="value-caption">Endenergiebedarf aus Messdaten</span>
        <span class="value">{{ displayValue() != null ? (displayValue() | number: '1.0-1': 'de') : '–' }}</span>
        <span class="unit">kWh/m²·a</span>
      </div>
      @if (certifiedValue() != null) {
        <div class="value-block certified">
          <span class="value-caption">Endenergiebedarf laut Energieausweis</span>
          <span class="value">{{ certifiedValue() | number: '1.0-1': 'de' }}</span>
          <span class="unit">kWh/m²·a</span>
        </div>
      }
    </div>
    <div class="class-badge" [style.background]="classColor()" [style.color]="classTextColor()">{{ classLabel() }}</div>
  </div>

  @if (insufficientData()) {
    <div class="insufficient-hint">
      Unzureichende Daten für eine aussagekräftige Berechnung – siehe Aufschlüsselung.
    </div>
  }

  <div class="scale">
    @if (pointerPercent() != null) {
      <div class="pointer" [style.left.%]="pointerPercent()">
        <div class="pointer-triangle"></div>
      </div>
    }
    <div class="segments">
      @for (segment of segments(); track segment.key) {
        <div class="segment" [class.active]="segment.active" [style.background]="segment.color" [style.color]="segment.textColor">
          {{ segment.label }}
        </div>
      }
    </div>
  </div>

  @if (periodStart() && periodEndInclusive()) {
    <div class="period">
      Zeitraum: {{ periodStart() | date: 'MM.yyyy' }} – {{ periodEndInclusive() | date: 'MM.yyyy' }}
    </div>
  }

  @if (breakdown().length) {
    <div class="breakdown">
      <div class="breakdown-title">Aufschlüsselung</div>
      @for (contribution of breakdown(); track $index) {
        <div class="breakdown-row">
          <span class="breakdown-label">{{ contributionLabel(contribution) }}</span>
          @if (forecastHint(contribution); as hint) {
            <nb-icon class="breakdown-forecast" pack="eva" icon="info-outline" tabindex="0" role="img"
                     [nbTooltip]="hint" [attr.aria-label]="hint"></nb-icon>
          }
          @if (warningLabel(contribution.warningReason); as warning) {
            <span class="breakdown-warning">{{ warning }}</span>
          }
          <span class="breakdown-value">{{ contribution.signedValue | number: '1.0-1': 'de' }} kWh/m²·a</span>
        </div>
      }
    </div>
  }

  @if (trendPoints()) {
    <div class="trend">
      <div class="trend-title">Verlauf</div>
      <svg class="trend-svg" viewBox="0 0 100 30" preserveAspectRatio="none">
        <polyline class="trend-line" [attr.points]="trendPoints()" fill="none" stroke-width="1.5" />
        @for (marker of trendMarkers(); track $index) {
          <circle class="trend-point" [attr.cx]="marker.x" [attr.cy]="marker.y" r="1.5">
            <title>{{ marker.point.created | date: 'MM.yyyy' }}: {{ marker.point.value | number: '1.0-1': 'de' }} kWh/m²·a</title>
          </circle>
        }
      </svg>
      <div class="trend-dates">
        <span>{{ trendStart()?.created | date: 'MM.yyyy' }}</span>
        <span>{{ trendEnd()?.created | date: 'MM.yyyy' }}</span>
      </div>
    </div>
  }
</div>
